<div class="recent-tech-support-list">
    <div class="recent-tech-support-list__title">
        <div>
            <cds-icon
                shape="link"
                size="sm"
            ></cds-icon>
            {{ l10nKeys.title | vtranslate }}
        
        </div>
    </div>

    <ng-container *ngIf="node else nodeListEmpty">
        <avi-card class="recent-tech-support-node-status-card">
            <avi-card_header class="recent-tech-support-node-status-card__main-header">
                <div class="recent-tech-support-node-status-card__main-header__tile recent-tech-support-node-status-card__main-header__tile--with-icon">
                    <div class="recent-tech-support-node-status-card__main-header__tile-icon">
                        <cds-icon
                            shape="bundle"
                            size="sm"
                            status="success"
                        ></cds-icon>
                    </div>

                    <div class="recent-tech-support-node-status-card__main-header__tile-content">
                        <div class="recent-tech-support-node-status-card__main-header__tile-title">{{ nodeType }}</div>
                        <div 
                            class="recent-tech-support-node-status-card__main-header__tile-name" 
                            title="{{ nodeName }}"
                        >{{ nodeName }}</div>
                    </div>

                    <div class="recent-tech-support-node-status-card__main-header__tile-action-icons-container">

                        <div
                            class="recent-tech-support-node-status-card__main-header__tile-action-icon"
                            title="{{ l10nKeys.viewTranscriptTooltipLabel | vtranslate }}"
                        >
                            <cds-icon
                                shape="chat-bubble"
                                class="sel-view-transcript-button"
                                size="sm"
                                status="info"
                                (click)="openTranscriptModal()"
                            ></cds-icon>
                        </div>

                        <div class="recent-tech-support-node-status-card__main-header__tile-action-icon">
                            <cds-icon
                                shape="angle"
                                class="sel-recent-tech-support-details-toggle-button"
                                [direction]="showExpanded ? 'down' : 'up'"
                                (click)="toggleExpansion()"
                            ></cds-icon>
                        </div>
                    </div>
                </div>
            </avi-card_header>
            <avi-card_body>
                <div
                    class="recent-tech-support-node-status-card__main-header__tile recent-tech-support-node-status-card__main-header__tile--body"
                    *ngIf="showExpanded"
                >
                    <ng-container>
                        <div class="recent-tech-support-node-status-card__main-header__tile-title">{{ l10nKeys.durationLabel | vtranslate }}</div>
                        <div>{{ nodeDuration }}</div>

                        <div class="recent-tech-support-node-status-card__main-header__tile-title recent-tech-support-node-status-card__main-header__tile-title--started">{{ l10nKeys.sizeLabel | vtranslate }}</div>
                        <div>{{ nodeSize }}MB</div>
                    </ng-container>
                </div>
            </avi-card_body>
            <avi-card_footer>
                <div class="recent-tech-support-node-status-card__main-header__tile recent-tech-support-node-status-card__main-header__tile--with-icon recent-tech-support-node-status-card__main-header__tile--footer">
                    <div
                        title="{{ nodeStatusDescription }}"
                        class="recent-tech-support-node-status-card__main-header__tile-icon-container"
                    >
                        <cds-icon
                            shape="{{ statusIconInfo.shape }}"
                            status="{{ statusIconInfo.status }}"
                            size="md"
                        ></cds-icon>
                    </div>
                    <div>{{ nodeStateGroupLabel }}</div>
                </div>
            </avi-card_footer>
        </avi-card>
    </ng-container>

    <ng-template #nodeListEmpty>
        <div class="recent-tech-support-list__no-tiles-placeholder">{{ l10nKeys.emptyListPlaceholder | vtranslate }}</div>
    </ng-template>
</div>

<tech-support-wizard
    *ngIf="openViewTranscriptWizard"
    (onClose)="onClose()"
    [selectedPackage]="node"
></tech-support-wizard>
